import { useEffect, useState } from "react";
import { api } from "../../lib/api";

export default function AdminSubmissions() {
  const [subs, setSubs] = useState([]);
  useEffect(() => {
    api.get("/submissions").then((r) => setSubs(r.data));
  }, []);

  return (
    <div data-testid="admin-submissions">
      <div className="text-xs uppercase tracking-[0.3em] text-zinc-500 mb-3">Inbox</div>
      <h1 className="font-display text-4xl tracking-tighter mb-10">Submissions</h1>

      <div className="border border-white/10 bg-[#0A0A0A]">
        <table className="w-full text-sm">
          <thead>
            <tr className="border-b border-white/10 text-left text-xs uppercase tracking-[0.2em] text-zinc-500">
              <th className="px-4 py-3 font-normal">Date</th>
              <th className="px-4 py-3 font-normal">Type</th>
              <th className="px-4 py-3 font-normal">Name</th>
              <th className="px-4 py-3 font-normal">Email</th>
              <th className="px-4 py-3 font-normal">Phone</th>
              <th className="px-4 py-3 font-normal">Message</th>
              <th className="px-4 py-3 font-normal">Brand</th>
            </tr>
          </thead>
          <tbody>
            {subs.map((s) => (
              <tr key={s.id} className="border-b border-white/5">
                <td className="px-4 py-3 text-zinc-400 whitespace-nowrap">{new Date(s.created_at).toLocaleString()}</td>
                <td className="px-4 py-3 text-zinc-400">{s.type}</td>
                <td className="px-4 py-3 font-medium">{s.name}</td>
                <td className="px-4 py-3 text-zinc-400">{s.email}</td>
                <td className="px-4 py-3 text-zinc-400">{s.phone || "—"}</td>
                <td className="px-4 py-3 text-zinc-300 max-w-md">{s.message}</td>
                <td className="px-4 py-3 text-zinc-400">{s.brand_slug || "main"}</td>
              </tr>
            ))}
            {subs.length === 0 && <tr><td colSpan={7} className="px-4 py-10 text-center text-zinc-500">No submissions yet.</td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  );
}
